import { Grid } from '@mui/material'
import { SimpleForm, TextInput, required, DateTimeInput, BooleanInput } from 'react-admin'
import dayjs from 'dayjs'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { CreateBase } from '../../components/base'
import { isAfterDate, isBeforeDate } from '../../utils/validators'
import { ImageField} from '../../components/fields'
import {
  ActionSelectInput,
  ApproveAndPublishToolBar,
  TextInputTargetValue,
} from '../../components/form'
import { PromotionTargetLinkSelectInput } from '../../components/domains/promotion/PromotionTargetLinkSelectInput'
import { PromotionSelectInput } from '../../components/domains/promotion/PromotionSelectInput'
import { ImageBannerInput } from '../../components/inputs/ImageBannerInput'

const RESOURCE_PREFIX = 'resources.promotions.banners.create'

const PromotionBannerCreate = (): JSX.Element => {
  const defaultDate = dayjs()
  const defaultExpireDate = defaultDate.add(1, 'month')
  return (
    <CreateBase
      title={`${RESOURCE_PREFIX}.title`}
      listAction={{
        hasBackButton: true,
      }}
      encType='multipart/form-data'
    >
      <SimpleForm toolbar={<ApproveAndPublishToolBar encType='multipart/form-data' />}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <ImageBannerInput
              source='image'
              label={`${COMMON_FIELDS}.image.label`}
              accept='image/*'
            >
              <ImageField source='src' title='title' />
            </ImageBannerInput>
          </Grid>
          <Grid item xs={12} md={4}>
            <ActionSelectInput></ActionSelectInput>
          </Grid>
          <Grid item xs={12} md={4}>
            <PromotionTargetLinkSelectInput></PromotionTargetLinkSelectInput>
          </Grid>
          <Grid item xs={12} md={4}>
            <PromotionSelectInput size='small'></PromotionSelectInput>
            <TextInputTargetValue
              label={`${COMMON_FIELDS}.target_link.label`}
              source='target_link'
            ></TextInputTargetValue>
          </Grid>
          <Grid item xs={4}>
            <DateTimeInput
              source='start_date'
              label={`${COMMON_FIELDS}.date.published_on`}
              fullWidth
              defaultValue={defaultDate}
              validate={[
                required(),
                isBeforeDate('end_date', 'The publish date must be in before the expired date.'),
              ]}
            />
          </Grid>
          <Grid item xs={4}>
            <DateTimeInput
              source='end_date'
              label={`${COMMON_FIELDS}.date.expired_on`}
              fullWidth
              defaultValue={defaultExpireDate}
              validate={[
                required(),
                isAfterDate('start_date', 'The expired date must be in after the publish date.'),
              ]}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <BooleanInput
              source='is_highlight'
              label={`${COMMON_FIELDS}.highlight.label`}
              sx={{ '& .MuiFormControlLabel-root': { marginRight: 'auto' }, display: 'none' }}
              defaultValue={true}
            />
          </Grid>
        </Grid>
        <TextInput
          sx={{ display: 'none' }}
          source='order'
          label={`${COMMON_FIELDS}.order`}
          fullWidth
          defaultValue={0}
        />
      </SimpleForm>
    </CreateBase>
  )
}

export default PromotionBannerCreate
